/**
 * کاشیِ جای فلشِ رفته: هر فلشی که بیرون می‌رود، خانه‌هایش را کاشی می‌کند و تخته‌ی خالی‌شده نقشِ همان مرحله را
 * کاشی‌کاری‌شده نشان می‌دهد — پیش از این، پایانِ مرحله یک تخته‌ی سفیدِ خالی بود و جایزه خودش را پاک می‌کرد.
 *
 * رنگ با حلقه‌های گردِ مرکزِ تخته عوض می‌شود، مثلِ ترنجِ کاشی‌کاری: طلایی وسط، بعد شیری، لاجورد و فیروزه. فاصله
 * به اندازه‌ی تخته بسته است، نه به شمارِ خانه‌ها، تا تخته‌ی بازی و نقشِ کوچکِ نوارِ مرحله‌ها (Thumb) یک‌جور رنگ شوند.
 * همین قاعده در اپ هم هست (ArrowsTiles.cs).
 */

/** نوعِ کاشی: ۰ طلایی، ۱ شیری، ۲ لاجورد، ۳ فیروزه. */
export type TileKind = 0 | 1 | 2 | 3;

/** رنگِ زمینه‌ی هر نوع، و رنگِ نقشِ کوچکِ وسطش (ستاره‌ی چهارپر). */
export const TILE_BASE = ["#c99613", "#f1e4c3", "#1e4f91", "#1f9aa5"] as const;
export const TILE_MOTIF = ["#f6ecd2", "#1e4f91", "#f1e4c3", "#f6ecd2"] as const;

/** حلقه‌ها از مرکز به بیرون. */
const RINGS: readonly TileKind[] = [0, 1, 2, 3, 2, 1, 2, 3, 2, 2];

/**
 * چند حلقه در نیم‌قطرِ تخته: هفت روی تخته‌ی بزرگ، کمتر روی تخته‌ی کوچک تا هر حلقه دست‌کم یک خانه و نیم پهن باشد —
 * وگرنه روی تخته‌ی ۹ خانه‌ای رنگ‌ها درهم می‌شدند. نقشِ کوچکِ جانور (۳۲ ستون) و تخته‌ی بزرگش هر دو هفت دارند.
 */
const ringSteps = (w: number, h: number) => Math.min(7, Math.max(3, Math.floor(Math.min(w, h) / 3)));

/**
 * فاصله‌ی خانه از مرکزِ تخته: ۰ وسط، ۱ لبه‌ی میانی، تا حدودِ ۱٫۴ در گوشه. sqrt و نه hypot: sqrt در JS و C# یک‌جور
 * گرد می‌شود، پس اپ (ArrowsTiles.cs) همین رنگ‌ها را می‌گیرد.
 */
export function ringOf(x: number, y: number, w: number, h: number): number {
  const dx = (x + 0.5 - w / 2) / (w / 2), dy = (y + 0.5 - h / 2) / (h / 2);
  return Math.sqrt(dx * dx + dy * dy);
}

export function tileKind(x: number, y: number, w: number, h: number): TileKind {
  return RINGS[Math.min(RINGS.length - 1, Math.floor(ringOf(x, y, w, h) * ringSteps(w, h)))]!;
}

/** کاشیِ گوشه‌گرد در خانه‌ی (x, y)، با درزِ سفید دورش. */
export function tilePath(x: number, y: number): string {
  return `M${x + 0.06} ${y + 0.22}q0 -.16 .16 -.16h.56q.16 0 .16 .16v.56q0 .16 -.16 .16h-.56q-.16 0 -.16 -.16z`;
}

/** ستاره‌ی چهارپرِ کوچکِ وسطِ کاشی. */
export function motifPath(x: number, y: number): string {
  const cx = x + 0.5, cy = y + 0.5;
  return `M${cx} ${cy - 0.22}L${cx + 0.06} ${cy - 0.06}L${cx + 0.22} ${cy}L${cx + 0.06} ${cy + 0.06}L${cx} ${cy + 0.22}`
    + `L${cx - 0.06} ${cy + 0.06}L${cx - 0.22} ${cy}L${cx - 0.06} ${cy - 0.06}z`;
}
